const Applawsuit = () => import('@/module/index/layout/Applawsuit.vue')
const applylawsuit = () => import('@/module/index/pages/lawsuit/applylawsuit.vue')
const lawsuitdetail = () => import('@/module/index/pages/lawsuit/lawsuitdetail.vue')
export default {
  path: '/lawsuit',
  component: Applawsuit,
  // redirect: '/consultation/evaluate',
  meta: {
    title: '',
    requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
    isback: false
  },
  children: [{
    path: '/lawsuit/apply/:id', // 申请诉讼
    component: applylawsuit
  },
  {
    path: '/lawsuit/detail/:id', // 诉讼详情
    component: lawsuitdetail
  }
  ]
}



// WEBPACK FOOTER //
// ./src/publicResource/router/lawsuit.js